<template>
  <AtomsContainersCornerBorders>
    <MoleculesBlocksVideoItem :youtube-id="props.id" />
  </AtomsContainersCornerBorders>
</template>
<script setup>

const props = defineProps({
    id: String
});

</script>